// extracted by mini-css-extract-plugin
export default {"root":"y5D7dU6J","item":"QoiQkInk","title":"_3waNzIhV","titleIcon":"HG9RJKh6","opened":"_2KTSq8ix","titleText":"_3hUppOLG","content":"OAwk2-ei"};